import React from "react";
import { LookupOrdersByEmailConfirmationBody } from "tsi-common-react/src/apps/customer-account/LookupOrdersByEmailConfirmationBody/index";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.LookupOrdersByEmailConfirmationDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <LookupOrdersByEmailConfirmationBody {...props} />
    </PageSkeleton>
);
